/* eslint-disable no-nested-ternary */
/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';

import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Grid, Container } from '@material-ui/core';

import Icons from 'consts/icons';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import PermissionsGate from 'components/common/PermissionGate';
import { SCOPES } from 'consts/permission-maps';
import { userStyles } from 'consts/styles/User';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Tooltip from '@material-ui/core/Tooltip';
import { formStyles } from 'consts/styles/Form';
import CorridorChart from './manageApprovedAreas/charts/ApprovedAreasChart';

const DisplayAreaDetails = props => {
  const { areaToDisplay, zoom, edit, remove } = props;

  const subtitles = useSelector(state => state.language).zonesDetails;
  const heightUnit = useSelector(state => state.heightUnit);

  const userSettingObject = UserSessionDataHandler.getUserSettingsObject();
  const lang =
    userSettingObject &&
    userSettingObject[UserSessionDataHandler.defaultLanguage]
      ? userSettingObject[UserSessionDataHandler.defaultLanguage]
      : 'en';

  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  return (
    <div>
      {areaToDisplay ? (
        <Grid container className={`${classesUser.User}__settings`}>
          <div className={`${classesUser.User}__settings__content__spacer`} />
          <div
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--direction ${formClasses.Form}--flex--flex-end`}
          >
            <Container>
              <Grid
                container
                spacing={1}
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
              >
                <Grid item xs={12}>
                  <CorridorChart
                    foundArea={areaToDisplay}
                    chartCases={false}
                    height="240px"
                    showLegend={false}
                  />
                </Grid>
              </Grid>
            </Container>
            <Container>
              <Grid
                container
                spacing={1}
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
              >
                <Grid item xs={12}>
                  <div className={`${formClasses.Form}__label`}>
                    {`${subtitles.uid_}: `}
                    <span
                      className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                    >
                      {areaToDisplay.uid}
                    </span>
                  </div>
                </Grid>
              </Grid>
            </Container>
            <Container>
              <Grid
                container
                spacing={1}
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
              >
                <Grid item xs={9}>
                  <div className={`${formClasses.Form}__label`}>
                    {subtitles.name_}
                  </div>
                  <div className={`${formClasses.Form}__text-field`}>
                    {areaToDisplay.uid.substring(0, 8)}
                  </div>
                </Grid>
                <Grid
                  item
                  xs={3}
                  align="right"
                  className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
                >
                  <PermissionsGate scopes={[SCOPES.canChangeCorridor]}>
                    <Tooltip title={subtitles.edit_} placement="left">
                      <Button
                        onClick={() => edit(areaToDisplay)}
                        fullWidth
                        className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                      >
                        <Icons.Actions.Edit2 />
                      </Button>
                    </Tooltip>
                  </PermissionsGate>

                  <Tooltip title={subtitles.zoom_} placement="right">
                    <Button
                      type="button"
                      fullWidth
                      onClick={() => zoom(areaToDisplay.geojson)}
                      className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                    >
                      <Icons.Zoom.ZoomInOnMap />
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Container>
            <Container>
              <Grid
                container
                spacing={1}
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--height--dashboard-min-height`}
              >
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.name_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {areaToDisplay.name || areaToDisplay.othername}
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.type_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {areaToDisplay.type}
                  </span>
                </Grid>

                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.heightMin_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {`${areaToDisplay.agl_min} ${heightUnit}`}
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.heightMax_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {`${areaToDisplay.agl_max} ${heightUnit}`}
                  </span>
                </Grid>
                {(areaToDisplay.description ||
                  areaToDisplay.description === '') && (
                  <Grid item xs={12}>
                    <span className={`${formClasses.Form}__label`}>
                      {subtitles.description_}
                    </span>
                    <br />
                    <span
                      className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                    >
                      {areaToDisplay.description[lang] ||
                        areaToDisplay.description}
                    </span>
                  </Grid>
                )}

                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.visibilityType_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {areaToDisplay.visibility ? (
                      <>
                        <Icons.Filters.ButtonPrivate /> {subtitles.private_}
                      </>
                    ) : (
                      <>
                        <Icons.Filters.ButtonPublic /> {subtitles.public_}
                      </>
                    )}
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.activityType_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {areaToDisplay.active ? (
                      <>
                        <Icons.Filters.ActionSuccess />
                        {subtitles.activeYes_}
                      </>
                    ) : (
                      <>
                        <Icons.Filters.ActionFail />
                        {subtitles.activeNo_}
                      </>
                    )}
                  </span>
                </Grid>

                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.contact_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {areaToDisplay.contact || '-'}
                  </span>
                </Grid>
                <Grid item xs={6}>
                  <span className={`${formClasses.Form}__label`}>
                    {subtitles.width_}
                  </span>
                  <br />
                  <span
                    className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                  >
                    {`${areaToDisplay.width} m` || '-'}
                  </span>
                </Grid>
                <Grid item xs={12}>
                  <PermissionsGate scopes={[SCOPES.canDeleteCorridor]}>
                    <Button
                      onClick={() => remove(areaToDisplay.uid)}
                      startIcon={<Icons.Actions.Clear />}
                      className={`${formClasses.Form}--width ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} ${classesButtons.Buttons}--reject`}
                    >
                      {subtitles.remove_}
                    </Button>
                  </PermissionsGate>
                </Grid>
              </Grid>
            </Container>
          </div>
        </Grid>
      ) : null}
    </div>
  );
};

DisplayAreaDetails.propTypes = {
  areaToDisplay: PropTypes.object.isRequired,
  zoom: PropTypes.func.isRequired,
  edit: PropTypes.func,
  remove: PropTypes.func,
};

export default DisplayAreaDetails;
